<template>
  <div id="samToolbar" class="sam-sidebar">
    <div v-if="aigtTaskId" class="sam-sidebar__section">
      <div class="sam-sidebar__title">AGTG Task</div>
      <TaskData
        :session="aigtTaskForDisplay"
        :task-name="aigtTaskForDisplay.name"
        :start-date="aigtTaskForDisplay.date || aigtTaskForDisplay.created_at || ''"
        :duration="aigtTaskForDisplay.formatted_duration || ''"
        :user-list="[]"
          :permissions="{ trainer_write: true }"
        :show-logs="false"
          :can-delete="true"
        :session-status="aigtTaskForDisplay.status"
        :status-info="aigtTaskForDisplay.status_info"
        :message="aigtTaskForDisplay.message"
        :task-u-i-d="encodeID(aigtTaskId, 'bt-')"
        :user-name="aigtTaskForDisplay.username || ''"
        :process-info="aigtTaskProcessInfo"
        @refresh="fetchAigtTask"
          @delete="handleAigtTaskStopped"
          @terminate-session="handleAigtTaskStopped"
      />
    </div>

    <!-- Server is ACTIVE -->
    <template v-if="sam2Server && isSam2ServerFound && isSam2ServerAvailable && hasInitState && !isInitializingState">
      <!-- Objects -->
      <div class="sam-sidebar__section objects">
        <h2 class="sam-sidebar__title">
          1. Select Objects
          <IconButton
            id="SAMAddObjectBtn"
            v-tooltip="'Add Object (N)'"
            aria-label="Add Object (N)"
            class="sam-toolbar__button"
            :icon="'add'"
            :showHover="true"
            :type="''"
            :width="20"
            :height="20"
            @click="handleSAMAddObject"
          />
        </h2>
        <div class="objects__cards scrollbar">
          <div
            v-for="(obj_id, i) in objects"
            :key="obj_id"
            class="objects-card"
            :class="{_selected: selectedObject === obj_id}"
            @click="selectedObject = obj_id"
          >
            <div class="objects-card__title">
              <!-- {{ objectsLabelMap[obj_id] ? uppercaseFirstLetter(objectsLabelMap[obj_id].name) : 'Object' }} {{ i + 1 }} -->
              <select class="select label-select" required @change="($event) => handleAssignLabel($event.target.value)">
                <option
                  v-for="(label, i) in labels"
                  :key="i"
                  :selected="objectsLabelMap && objectsLabelMap[obj_id] && objectsLabelMap[obj_id].id === label.id"
                  :value="label.id"
                >
                  {{ label.name }}
                </option>
              </select>
              <div v-if="isAddingNewPointsOrBox && selectedObject === obj_id" title="Waiting for server" class="ms-1">
                <div class="loader-ring"><div /><div /><div /><div /></div>
              </div>
            </div>
            <template v-if="selectedObject === obj_id">
              <div class="objects-card__buttons">
                <div class="sam-toolbar__button-container">
                  <IconButton
                    id="SAMhoverAndClickToolAddBtn"
                    v-tooltip="'SAM Hover and Click (Left Click: positive point, Right Click: negative point)'"
                    aria-label="SAM Hover and Click (Add)"
                    class="sam-toolbar__button"
                    :class="{active: pointType === 'add'}"
                    :icon="'cursor'"
                    :showHover="true"
                    :type="''"
                    :width="20"
                    :height="20"
                    :disabled="!hasInitState"
                    @click="handleSAMHoverAndClickAdd"
                  />
                  <SVGIcon
                    id="SAMhoverAndClickToolBtn"
                    class="sam-toolbar__button-pointer-overlay"
                    :iconName="'add_box_outlined'"
                  />
                </div>
                <div class="sam-toolbar__button-container">
                  <IconButton
                    id="SAMhoverAndClickToolMinusBtn"
                    v-tooltip="'SAM Hover and Click (Minus)'"
                    aria-label="SAM Hover and Click (Minus)"
                    class="sam-toolbar__button"
                    :class="{active: pointType === 'minus'}"
                    :icon="'cursor'"
                    :showHover="true"
                    :type="''"
                    :width="20"
                    :height="20"
                    :disabled="!hasInitState"
                    @click="handleSAMHoverAndClickMinus"
                  />
                  <SVGIcon
                    id="SAMhoverAndClickToolBtn"
                    class="sam-toolbar__button-pointer-overlay"
                    :iconName="'minus_box_outlined'"
                  />
                </div>
                <IconButton
                  id="SAMhoverAndClickToolBtn"
                  v-tooltip="'SAM Box Tool'"
                  aria-label="SAM Box Tool"
                  class="sam-toolbar__button"
                  :class="{active: pointType === 'box'}"
                  :icon="'highlight_alt'"
                  :showHover="true"
                  :type="''"
                  :width="20"
                  :height="20"
                  :disabled="!hasInitState"
                  @click="handleSAMAddBox"
                />
                <IconButton
                  id="SAMSelectExistingBoxBtn"
                  v-tooltip="'Select Existing Box (X): click an existing 2D bounding box to select its object. The box is used as the SAM prompt to add a polygon to the object, if it does not already have one.'"
                  aria-label="SAM Select Existing Box (X)"
                  class="sam-toolbar__button"
                  :class="{active: pointType === 'select_box'}"
                  :icon="'box-tool'"
                  :showHover="true"
                  :type="''"
                  :width="20"
                  :height="20"
                  :disabled="!hasInitState"
                  @click="handleSAMSelectExistingBox"
                />
                <!-- <IconButton
                id="SAMUndoBtn"
                aria-label="Undo"
                class="sam-toolbar__button"
                :icon="'undo'"
                :showHover="true"
                :type="''"
                v-tooltip="'Undo'"
                :width="20"
                :height="20"
                :disabled="!hasInitState"
                @click="handleSAMUndo"
              /> -->
                <button
                  v-if="hasInitState"
                  v-tooltip="'Clear Object'"
                  class="button button-sm sam-toolbar__button _secondary flex-icon-button ms-auto"
                  aria-label="Clear Object"
                  :disabled="!hasInitState"
                  @click="handleSAMClearAllPromptsInFrame(obj_id)"
                >
                  Clear
                </button>
              </div>
            </template>
            <template v-else>
              <div class="objects-card__buttons">
                <button
                  v-tooltip="'Edit Object'"
                  class="button button-sm sam-toolbar__button _secondary flex-icon-button objects-card__edit-button"
                  aria-label="Edit Object"
                  :disabled="!hasInitState"
                  @click="selectedObject = obj_id"
                >
                  <SVGIcon
                    :iconName="'edit'"
                    :width="16"
                    :height="16"
                    class="me-1"
                  />
                  Edit Object {{ i + 1 }}
                </button>
                <button
                  v-tooltip="'Clear Object'"
                  class="button button-sm sam-toolbar__button _secondary flex-icon-button"
                  aria-label="Clear Object"
                  :disabled="!hasInitState"
                  @click="handleSAMClearAllPromptsInFrame(obj_id)"
                >
                  <SVGIcon
                    :iconName="'delete'"
                    :width="16"
                    :height="16"
                    class="me-1"
                  />
                  Clear
                </button>
              </div>
            </template>
            <IconButton
              v-if="hasInitState"
              v-tooltip="'Remove Object'"
              :icon="'close'"
              :width="16"
              :height="16"
              class="objects-card__close"
              aria-label="Remove Object"
              :disabled="!hasInitState"
              @click="handleSAMRemoveObject(obj_id)"
            />
          </div>
        </div>
        <button
          v-if="hasInitState"
          class="button button-sm sam-toolbar__button _secondary flex-icon-button"
          :disabled="!hasInitState"
          @click="handleStartOver"
        >
          <SVGIcon
            :iconName="'replay'"
            :width="16"
            :height="16"
            class="me-1"
          />
          Start Over
        </button>
      </div>

      <!-- Propagate -->
      <div v-if="currentSample?.imageObj?.sequence_id" class="sam-sidebar__section propagate">
        <h2 class="sam-sidebar__title">
          2. Propagate
          <SVGIcon
            v-tooltip="`Propagate 2D bounding boxes and segmenation masks from the current frame to other frames if the same object is tracked.`"
            :width="'20px'"
            :height="'20px'"
            :iconName="'info'"
            class="help-icon"
          />
        </h2>
        <div class="init-state__inputs">
          <v-number-input
            v-model="frame"
            :min="1"
            :reverse="false"
            :height="24"
            :width="120"
            controlVariant="stacked"
            label="Start Frame"
            density="compact"
            variant="outlined"
            :hide-details="true"
            disabled
          />
          <v-number-input
            v-model="endFrameModel"
            :min="reversePropagateEnabled ? 1 : frame + 1"
            :max="reversePropagateEnabled ? frame : numFrames"
            :reverse="false"
            :height="24"
            :width="120"
            controlVariant="stacked"
            label="End Frame"
            density="compact"
            variant="outlined"
            :hide-details="true"
          />
        </div>
        <v-checkbox
          v-model="reversePropagateEnabled"
          color="#250e81"
          :hide-details="true"
          :density="'compact'"
          class="non-opaque-label"
        >
          <template #label>
            <span class="check-box-text">Reverse Propagate</span>
            <SVGIcon
              v-tooltip="`If true, propagte frames backwards starting from the current frame. Otherwise, propagate forward.`"
              :width="'20px'"
              :height="'20px'"
              :iconName="'info'"
              class="help-icon"
            />
          </template>
        </v-checkbox>
        <div class="propagate__buttons">
          <div class="propagate__buttons-main">
            <button
              v-tooltip="!hasInitState || isPropagating || sam2Annotations.length === 0 ? 'Requires at least one annotation to propagate.' : 'Propagate from start to end frame.'"
              class="button button-sm sam-toolbar__button propagate__action-button"
              :class="{'button-spinner': isPropagating}"
              :disabled="!hasInitState || isPropagating || sam2Annotations.length === 0"
              @click="handleInitStateThenPropagate"
            >
              {{ isPropagating ? propagateDetail : "Propagate" }}
            </button>
          <!-- <IconButton
            id="SAMReversePropagateBtn"
            v-model="reversePropagateEnabled"
            aria-label="Reverse Propagate"
            class="sam-toolbar__button"
            :icon="'swap_horiz'"
            :showHover="true"
            :type="'toggle'"
            v-tooltip="'Reverse Propagate'"
            :width="20"
            :height="20"
            :disabled="!hasInitState"
          /> -->
          </div>
          <button
            v-if="isPropagating"
            class="button button-sm sam-toolbar__button propagate__cancel-button _danger"
            :class="{'button-spinner': isCancellingPropagation}"
            :disabled="isCancellingPropagation"
            @click="handleCancelPropagation"
          >
            Stop Propagation
          </button>
        </div>
      </div>
    </template>

  </div>

  <ConfirmModal
    ref="confirmModal"
    :messageHeader="confirmMessageHeader"
    :message="confirmMessage"
    :buttonClass="confirmButtonClass"
    :buttonText="confirmButtonText"
    @confirmed="confirmFunction"
  />
</template>

<script setup>
import {
  ref, watch, computed, onMounted, onUnmounted, toRefs,
} from 'vue';
import IconButton from '@/components/IconButton.vue';
import SVGIcon from '@/components/SVGIcon.vue';
import ConfirmModal from '@/components/ConfirmModal.vue';
import TaskData from '@/components/Apps/TaskData.vue';
import { useSAM2Store } from '@/stores/useSAM2Store.js';
import { storeToRefs } from 'pinia';
import { useStore } from 'vuex';
import { useToast } from 'vue-toast-notification';
import 'vue-toast-notification/dist/theme-sugar.css';
import { useEditorStore } from '@/stores/useEditorStore.js';
import { useEditorControlsStore } from '@/stores/useEditorControlsStore.js';
import { useViewerVisualizationsStore } from '@/stores/useViewerVisualizationsStore.js';
import DatastoreConnect from '@/assets/js/DatastoreFunctions/datastore-interface';
import { v4 as uuidv4 } from 'uuid';
import { useTimeoutPoll } from '@vueuse/core';
import useTasks from '@/composables/annotationTool/useTasks.js';
import { encodeID, getAnnotationTypes } from '@/assets/js/utils';

const emit = defineEmits(['mode', 'new-frame', 'server-inactive']);

const $toast = useToast();
const store = useStore();
const confirmModal = ref(null);
const confirmMessage = ref(null);
const confirmMessageHeader = ref(null);
const confirmButtonText = ref('');
const confirmFunction = ref(null);
const confirmButtonClass = ref(undefined);

const sam2Store = useSAM2Store();
const {
  sam2Server,
  sam2ServerIp,
  serverHealthCheckedOnce,
  isSam2ServerFound,
  isSam2ServerAvailable,
  sam2Options,
  sam2Annotations,
  sam2LastPropagatedAnnotations,
  aigt3dAnnotations,
  aigt3dLastPropagatedAnnotations,
  aigt2dAnnotations,
  aigt2dLastPropagatedAnnotations,
  isInitializingState,
  hasInitState,
  initStatus,
  initDetail,
  initProgress,
  initTotal,
  initError,
  initStartFrame,
  initEndFrame,
  initEndFrameReverse,
  isPropagating,
  propagateStatus,
  propagateDetail,
  propagateProgress,
  propagateTotal,
  propagateLastAnnotationIndex,
  shouldClearNextPoints,
  isCreatingAnnotations,
  reversePropagateEnabled,
  objects,
  objectsLabelMap,
  objectsBoxMap,
  selectedObject,
  isAddingNewPointsOrBox,
  isCancellingPropagation,
} = storeToRefs(sam2Store);
const {
  $resetServer,
  getFrameAndObjectSAM2LastPropagatedAnnotations,
  getFrameAndObjectAigt3dLastPropagatedAnnotations,
  getFrameAndObjectAigt2dLastPropagatedAnnotations,
  handleSAMAddObject,
  handleSAMReset,
  handleResetSAMState,
} = sam2Store;

const pointType = computed(() => sam2Options.value.params.pointType);

const endFrameModel = computed({
  get() {
    return reversePropagateEnabled.value ? initEndFrameReverse.value : initEndFrame.value;
  },
  set(value) {
    if (reversePropagateEnabled.value) {
      initEndFrameReverse.value = value;
    } else {
      initEndFrame.value = value;
    }
  },
});

const startFrameModel = computed({
  get() {
    return isPropagating.value ? initStartFrame.value : frame.value;
  },
  set(value) {
    if (isPropagating.value) {
      initStartFrame.value = value;
    } else {
      frame.value = value;
    }
  },
});

const fetchingServerHealth = ref(false);
let lastAigtErrorToast = { message: '', shownAt: 0 };

function showAigtErrorToast(error, fallbackMessage) {
  const message = error?.message || (typeof error === 'string' ? error : '') || fallbackMessage;
  if (/web\s*socket/i.test(message) && /not connected|disconnected|closed|failed|unable to connect|connection error|connection refused/i.test(message)) {
    return;
  }
  const now = Date.now();
  if (message === lastAigtErrorToast.message && now - lastAigtErrorToast.shownAt < 5000) {
    return;
  }

  lastAigtErrorToast = { message, shownAt: now };
  $toast.open({
    queue: true,
    duration: 5000,
    message,
    type: 'error',
    position: 'top',
  });
}

async function readAigtResponse(response, fallbackMessage) {
  const responseText = await response.text();
  let payload = null;
  try {
    payload = responseText ? JSON.parse(responseText) : null;
  } catch (error) {
    payload = null;
  }

  if (!response.ok || payload?.error) {
    const message = payload?.error?.message
      || payload?.message
      || payload?.detail
      || responseText
      || `${fallbackMessage} (HTTP ${response.status})`;
    throw new Error(message);
  }

  return payload;
}

const clicks = computed(() => [...sam2Options.value.params.clicks]);
watch(clicks, (newClicks, oldClicks) => {
  const clicksToAdd = newClicks;
  if (clicksToAdd.length > 0) {
    handlePredictImage({ clicks: clicksToAdd });
    sam2Options.value.params.box = [];
  }
}, { deep: true });

const box = computed(() => [...sam2Options.value.params.box]);
watch(box, async (newBox) => {
  if (newBox && newBox.length > 0) {
    handlePredictImage({ box: newBox });
    sam2Options.value.params.box = [];
  }
}, { deep: true });

const editorStore = useEditorStore();
const {
  sequenceId,
  labels,
  currentSample,
  selectedAnnotationIdentifiers,
  imageDimensions,
} = storeToRefs(editorStore);

const { selectedLabel } = storeToRefs(useEditorControlsStore());

const visualizationStore = useViewerVisualizationsStore();
const {
  samples,
  frame,
} = storeToRefs(visualizationStore);
const numFrames = computed(() => samples.value.length);
watch(numFrames, () => {
  if (numFrames.value && numFrames.value > 0) {
    initEndFrame.value = numFrames.value;
  }
}, { immediate: true });

const {
  destinationAnnotationSet,
} = useTasks();

const { isActive: isFetchServerHealthActive, pause: pauseFetchServerHealth, resume: resumeFetchServerHealth } = useTimeoutPoll(fetchServerHealth, 5000);
const { isActive: isFetchPropagateActive, pause: pauseFetchPropagateStatus, resume: resumeFetchPropagateStatus } = useTimeoutPoll(fetchPropagateStatus, 500);
const { isActive: isFetchAnnotationsActive, pause: pauseFetchAnnotationsStatus, resume: resumeFetchAnnotationsStatus } = useTimeoutPoll(fetchAnnotationsStatus, 1000);

const controller = ref(new AbortController());
const aigtTask = ref(null);
const aigtDisplayPhase = ref('starting');
const aigtInitStartedAt = ref(null);
const progressClock = ref(Date.now());
const taskInfoSocket = ref(null);
let taskInfoReconnectTimeout = null;
let isIntentionalTaskInfoSocketClose = false;
let progressClockInterval = null;

const aigtTaskId = computed(() => {
  const taskId = Number(sam2Server.value?.task_id);
  return Number.isInteger(taskId) && taskId > 0 ? taskId : null;
});
const aigtTaskForDisplay = computed(() => {
  const task = aigtTask.value || {
    id: aigtTaskId.value,
    name: 'AI Assisted Ground Truth',
  };
  const phaseDisplay = getAigtPhaseDisplay(task);
  return {
    ...task,
    status: phaseDisplay.status,
    message: phaseDisplay.message,
    status_info: {
      ...(task.status_info || {}),
      status: phaseDisplay.status,
      message: phaseDisplay.message,
      stage_name: phaseDisplay.status,
      stage_label: phaseDisplay.label,
      percent: phaseDisplay.percent,
    },
  };
});
const aigtTaskProcessInfo = computed(() => ({
  ...(aigtTaskForDisplay.value.status_process_info || { id: '', status: '' }),
  manage_type: aigtTaskForDisplay.value.manage_type || '',
}));

function getAigtPhaseDisplay(task) {
  if (initError.value) {
    return {
      status: 'error',
      label: 'Error',
      message: initError.value,
      percent: 0,
    };
  }

  if (aigtDisplayPhase.value === 'running') {
    return {
      status: 'running', label: 'Running', message: 'Server Ready for AIGT', percent: 100,
    };
  }

  if (aigtDisplayPhase.value === 'init') {
    const elapsed = progressClock.value - (aigtInitStartedAt.value || progressClock.value);
    return {
      status: 'init',
      label: 'Init',
      message: 'Initializing Process',
      percent: Math.min(99, Math.floor((elapsed / 60000) * 100)),
    };
  }

  const taskStartedAt = new Date(task.date || task.created_at || progressClock.value).getTime();
  const elapsed = Number.isFinite(taskStartedAt) ? progressClock.value - taskStartedAt : 0;
  return {
    status: 'starting',
    label: 'Starting',
    message: 'Starting Server (5 min progress)',
    percent: Math.max(0, Math.min(99, Math.floor((elapsed / 300000) * 100))),
  };
}

watch(sam2Server, (newVal, prevVal) => {
  if (sam2Server.value) {
    if (newVal && prevVal && newVal.ip !== prevVal.ip) {
      $resetServer();
      serverHealthCheckedOnce.value = false;
    }
    if (!isSam2ServerAvailable.value) {
      resumeFetchServerHealth();
    }
  }
}, { immediate: true });
watch(aigtTaskId, async (newTaskId, previousTaskId) => {
  if (newTaskId === previousTaskId) {
    return;
  }

  disconnectTaskInfoSocket();
  aigtTask.value = null;
  if (newTaskId) {
    await fetchAigtTask();
    connectTaskInfoSocket();
  }
}, { immediate: true });

async function fetchAigtTask() {
  if (!aigtTaskId.value) {
    return;
  }

  try {
    const dataConnect = new DatastoreConnect();
    const response = await dataConnect.api('task.get', { id: aigtTaskId.value });
    if (response?.error) {
      throw new Error(response.error?.message || JSON.stringify(response.error));
    }
    if (response?.result && typeof response.result === 'object') {
      aigtTask.value = response.result;
    }
  } catch (error) {
    console.error('Failed to fetch AGTG task:', error);
  }
}

function applyTaskInfoUpdate(update) {
  if (!update || Number(update.id) !== aigtTaskId.value) {
    return;
  }

  const statusUpdateRaw = update.status_update ?? update.statis_update ?? update.statusUpdate;
  const statusUpdate = statusUpdateRaw && typeof statusUpdateRaw === 'object' ? statusUpdateRaw : null;
  const currentTask = aigtTaskForDisplay.value;
  aigtTask.value = {
    ...currentTask,
    status: update.status ?? update.name ?? currentTask.status,
    message: statusUpdate?.message ?? update.message ?? currentTask.message,
    formatted_duration: update.formatted_duration ?? currentTask.formatted_duration,
    status_info: statusUpdate ? {
      ...(currentTask.status_info || {}),
      status: statusUpdate.status ?? currentTask.status_info?.status,
      message: statusUpdate.message ?? currentTask.status_info?.message,
      stage_name: statusUpdate.stage ?? currentTask.status_info?.stage_name,
      stage_label: statusUpdate.label ?? currentTask.status_info?.stage_label,
      percent: statusUpdate.percentage ?? currentTask.status_info?.percent,
      stage_number: statusUpdate.stage_number ?? currentTask.status_info?.stage_number,
      total_stages: statusUpdate.total_stages ?? currentTask.status_info?.total_stages,
    } : currentTask.status_info,
    status_process_info: update.status_process_info ?? currentTask.status_process_info,
    common_app_params: update.common_app_params ?? currentTask.common_app_params,
    app_info: update.app_info ?? currentTask.app_info,
  };
}

function handleAigtTaskStopped() {
  disconnectTaskInfoSocket();
  $resetServer();
  sam2Server.value = null;
  emit('mode', 'pointer');
}

function sendTaskInfoSubscription() {
  if (taskInfoSocket.value?.readyState === WebSocket.OPEN && aigtTaskId.value) {
    taskInfoSocket.value.send(JSON.stringify({ task_ids: [aigtTaskId.value] }));
  }
}

function disconnectTaskInfoSocket() {
  if (taskInfoReconnectTimeout) {
    clearTimeout(taskInfoReconnectTimeout);
    taskInfoReconnectTimeout = null;
  }
  isIntentionalTaskInfoSocketClose = true;
  if (taskInfoSocket.value) {
    if ([WebSocket.OPEN, WebSocket.CONNECTING].includes(taskInfoSocket.value.readyState)) {
      taskInfoSocket.value.close();
    }
    taskInfoSocket.value = null;
  }
}

function connectTaskInfoSocket() {
  if (!aigtTaskId.value) {
    return;
  }
  if (taskInfoSocket.value?.readyState === WebSocket.OPEN) {
    sendTaskInfoSubscription();
    return;
  }
  if (taskInfoSocket.value && [WebSocket.CONNECTING, WebSocket.CLOSING].includes(taskInfoSocket.value.readyState)) {
    return;
  }

  isIntentionalTaskInfoSocketClose = false;
  const protocol = window.location.protocol === 'https:' ? 'wss' : 'ws';
  const socket = new WebSocket(`${protocol}://${window.location.host}/ws/task_info`);
  taskInfoSocket.value = socket;
  socket.onopen = sendTaskInfoSubscription;
  socket.onmessage = (event) => {
    try {
      const payload = JSON.parse(event.data);
      const updates = Array.isArray(payload)
        ? payload
        : Array.isArray(payload?.tasks)
          ? payload.tasks
          : Array.isArray(payload?.data)
            ? payload.data
            : payload?.task
              ? [payload.task]
              : [payload];
      updates.forEach(applyTaskInfoUpdate);
    } catch (error) {
      console.error('Failed to parse AGTG task info:', error);
    }
  };
  socket.onclose = () => {
    taskInfoSocket.value = null;
    if (!isIntentionalTaskInfoSocketClose && aigtTaskId.value) {
      taskInfoReconnectTimeout = setTimeout(connectTaskInfoSocket, 10000);
    }
  };
}

function syncSelectedObjectLabel() {
  const singleObjectId = objects.value.length === 1 ? objects.value[0] : selectedObject.value;
  if (!singleObjectId) {
    return;
  }

  const objectLabel = objectsLabelMap.value[singleObjectId];
  if (objectLabel) {
    if (selectedObject.value !== singleObjectId) {
      selectedObject.value = singleObjectId;
    }
    if (!selectedLabel.value || selectedLabel.value.id !== objectLabel.id) {
      selectedLabel.value = objectLabel;
    }
    return;
  }

  const firstLabel = labels.value[0];
  if (firstLabel) {
    handleAssignLabel(firstLabel.id, singleObjectId);
  }
}

watch(frame, () => {
  syncSelectedObjectLabel();
});

watch(selectedObject, () => {
  syncSelectedObjectLabel();
});

function handleKeyDown(event) {
  if (['INPUT', 'TEXTAREA', 'SELECT'].includes(event.target.tagName)) {
    return;
  }
  if (event.key === 'n') {
    handleSAMAddObject();
  } else if (event.key === 'x' && hasInitState.value && !event.ctrlKey && !event.metaKey && !event.altKey) {
    handleSAMSelectExistingBox();
  }
}

onMounted(async () => {
  progressClockInterval = setInterval(() => {
    progressClock.value = Date.now();
  }, 1000);
  resumeFetchServerHealth();
  window.addEventListener('keydown', handleKeyDown);
});

onUnmounted(async () => {
  controller.value?.abort();
  pauseFetchServerHealth();
  pauseFetchPropagateStatus();
  pauseFetchAnnotationsStatus();
  disconnectTaskInfoSocket();
  clearInterval(progressClockInterval);
  window.removeEventListener('keydown', handleKeyDown);
});

function handleNewFrame() {
  if (currentSample.value?.imageObj?.sequence_id) {
    if (!isPropagating.value) {
      handleSetImage();
    }
  } else {
    handleSetImage();
  }
}

async function handleSAMInitReset() {
  initStatus.value = '';
  initDetail.value = '';
  initProgress.value = 0;
  initTotal.value = 0;
  initError.value = '';
  reversePropagateEnabled.value = false;
  propagateStatus.value = '';
  propagateDetail.value = '';
  propagateProgress.value = 0;
  propagateTotal.value = 0;

  // Reset SAM2 Controls
  sam2Options.value.mode = 'drag_box';
  sam2Options.value.params.pointType = 'box';
  sam2Options.value.params.clicks = [];
  sam2Options.value.params.box = [];
  sam2Options.value.params.boxes = [];
  objects.value = [];
  selectedObject.value = null;
  handleSAMAddObject();
  const firstLabel = labels.value[0];
  if (firstLabel) {
    handleAssignLabel(firstLabel.id);
  }

  // Reset SAM2 annotations
  sam2Annotations.value = [];
  aigt3dAnnotations.value = [];
  aigt2dAnnotations.value = [];
  // Reset SAM2 State
}

function handleSAMHoverAndClickAdd() {
  if (sam2Options.value.mode === 'hover_and_click' && sam2Options.value.params.pointType === 'add') {
    sam2Options.value.mode = null;
    sam2Options.value.params.pointType = null;
  } else {
    sam2Options.value.mode = 'hover_and_click';
    sam2Options.value.params.pointType = 'add';
  }
}

function handleSAMHoverAndClickMinus() {
  if (sam2Options.value.mode === 'hover_and_click' && sam2Options.value.params.pointType === 'minus') {
    sam2Options.value.mode = null;
    sam2Options.value.params.pointType = null;
  } else {
    sam2Options.value.mode = 'hover_and_click';
    sam2Options.value.params.pointType = 'minus';
  }
}

function handleSAMAddBox() {
  if (sam2Options.value.mode === 'drag_box' && sam2Options.value.params.pointType === 'box') {
    sam2Options.value.mode = null;
    sam2Options.value.params.pointType = null;
  } else {
    sam2Options.value.mode = 'drag_box';
    sam2Options.value.params.pointType = 'box';
  }
}

function handleSAMSelectExistingBox() {
  if (sam2Options.value.mode === 'select_box') {
    sam2Options.value.mode = null;
    sam2Options.value.params.pointType = null;
  } else {
    sam2Options.value.mode = 'select_box';
    sam2Options.value.params.pointType = 'select_box';
  }
}

function addPolygonToExistingAnnotation(annotationId, polygon) {
  if (!polygon) {
    $toast.open({
      queue: true, duration: 5000, message: 'SAM did not return a polygon for this box.', type: 'warning', position: 'top',
    });
    return;
  }
  const target = (currentSample.value?.annotations || []).find((anno) => anno.id === annotationId);
  if (!target || getAnnotationTypes(target).includes('segmentation')) {
    return;
  }
  // Kept pending until "Save AIGT Annotations", which writes it onto the existing annotation.
  sam2Annotations.value = [
    ...sam2Annotations.value.filter((anno) => anno.existing_annotation_id !== annotationId),
    {
      id: `${annotationId}-sam-polygon`,
      existing_annotation_id: annotationId,
      type: 'seg',
      polygon: JSON.stringify(polygon),
      label_index: target.label_index,
      label_id: target.label_id,
      label_name: target.label_name,
      score: 1,
      reviewStatus: 'verified',
      image_id: target.image_id,
      annotation_set_id: target.annotation_set_id,
      pending: true,
    },
  ];
}

watch(selectedAnnotationIdentifiers, (identifiers) => {
  if (sam2Options.value.mode !== 'select_box' || !hasInitState.value || identifiers?.length !== 1) {
    return;
  }
  const target = (currentSample.value?.annotations || []).find((anno) => anno.id === identifiers[0]);
  const types = getAnnotationTypes(target);
  if (!types.includes('box')) {
    return;
  }
  if (types.includes('segmentation')) {
    $toast.open({
      queue: true, duration: 3000, message: 'This object already has a polygon.', type: 'info', position: 'top',
    });
    return;
  }
  const { width, height } = imageDimensions.value || {};
  if (!width || !height) {
    return;
  }
  handlePredictImage({
    box: [target.x * width, target.y * height, (target.x + target.w) * width, (target.y + target.h) * height],
    targetAnnotationId: target.id,
  });
});

async function handleInitStateWs() {
  isInitializingState.value = true;

  const socket = new WebSocket(`ws://${sam2ServerIp.value}:80/ws/aigt/init_state?sequence_id=${sequenceId.value}&start_frame=${frame.value - 1}&end_frame=${initEndFrame.value - 1}`);

  socket.onopen = () => {
    console.log('WebSocket connection established');
  };

  socket.onmessage = (event) => {
    try {
      const message = JSON.parse(event.data);
      console.log('Received:', message);

      if (message?.progress) {
        initProgress.value = message.progress;
      }
      if (message?.total) {
        initTotal.value = message.total;
      }
      if (message?.status) {
        initStatus.value = message.status;
      }
      if (message?.detail) {
        initDetail.value = message.detail;
      }
      if (message.status === "complete") {
        isInitializingState.value = false;
        hasInitState.value = true;
      }
      if (message.status === "error") {
        isInitializingState.value = false;
        hasInitState.value = false;
        initError.value = message.detail;
      }
    } catch (error) {
      console.error('Error parsing WebSocket message:', error);
    }
  };

  socket.onerror = (error) => {
    console.error('WebSocket error:', error);
    isInitializingState.value = false;
    initError.value = error;
  };

  socket.onclose = (event) => {
    isInitializingState.value = false;
    if (event.wasClean) {
      console.log(`WebSocket closed cleanly, code=${event.code}, reason=${event.reason}`);
    } else {
      console.error('WebSocket connection closed unexpectedly');
    }
  };
}

function handleAssignLabel(eventId) {
  if (eventId) {
    const id = parseInt(eventId);
    const label = labels.value.find((e) => e.id === id);
    objectsLabelMap.value[selectedObject.value] = label;
    selectedLabel.value = label;

    sam2Annotations.value.forEach((ann, i) => {
      if (sam2Annotations.value[i].object_reference === selectedObject.value) {
        sam2Annotations.value[i].label_index = objectsLabelMap.value[selectedObject.value].index;
        sam2Annotations.value[i].label_id = objectsLabelMap.value[selectedObject.value].id;
        sam2Annotations.value[i].label_name = objectsLabelMap.value[selectedObject.value].name;
      }
    });
    aigt3dAnnotations.value.forEach((ann, i) => {
      if (aigt3dAnnotations.value[i].object_reference === selectedObject.value) {
        aigt3dAnnotations.value[i].label_index = objectsLabelMap.value[selectedObject.value].index;
        aigt3dAnnotations.value[i].label_id = objectsLabelMap.value[selectedObject.value].id;
        aigt3dAnnotations.value[i].label_name = objectsLabelMap.value[selectedObject.value].name;
      }
    });
    aigt2dAnnotations.value.forEach((ann, i) => {
      if (aigt2dAnnotations.value[i].object_reference === selectedObject.value) {
        aigt2dAnnotations.value[i].label_index = objectsLabelMap.value[selectedObject.value].index;
        aigt2dAnnotations.value[i].label_id = objectsLabelMap.value[selectedObject.value].id;
        aigt2dAnnotations.value[i].label_name = objectsLabelMap.value[selectedObject.value].name;
      }
    });
  }
}

const SET_IMAGE_RETRY_DELAY_MS = 5000;

function waitForSetImageRetry(signal) {
  return new Promise((resolve) => {
    const finish = () => {
      clearTimeout(timeoutId);
      signal.removeEventListener('abort', finish);
      resolve();
    };
    const timeoutId = setTimeout(finish, SET_IMAGE_RETRY_DELAY_MS);
    signal.addEventListener('abort', finish, { once: true });
  });
}

async function handleSetImage({ showErrorToast = true } = {}) {
  if (controller.value) {
    controller.value.abort();
  }
  controller.value = new AbortController();
  const currentSignal = controller.value.signal;

  if (!isSam2ServerAvailable.value) {
    return false;
  }
  isInitializingState.value = true;
  initError.value = '';
  const requestData = {
    image_id: samples.value && frame.value ? samples.value[frame.value - 1] : currentSample.value?.imageObj?.id,
    annotation_set_id: destinationAnnotationSet.value?.id,
  };
  while (!currentSignal.aborted) {
    try {
      const response = await fetch(`/aigt/image/set_image?ip=${sam2ServerIp.value}`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(requestData),
        signal: currentSignal,
      });
      const result = await readAigtResponse(response, 'Error setting image');
      if (result?.status !== 'complete') {
        throw new Error(result?.message || 'Image setup did not complete');
      }

      initError.value = '';
      isInitializingState.value = false;
      return true;
    } catch (error) {
      if (currentSignal.aborted) {
        break;
      }
      initError.value = error?.message || String(error);
      if (showErrorToast) {
        showAigtErrorToast(error, 'Error setting image');
      }
      await waitForSetImageRetry(currentSignal);
    }
  }

  isInitializingState.value = false;
  return false;
}

async function initializeAigtServer() {
  aigtDisplayPhase.value = 'init';
  aigtInitStartedAt.value = Date.now();
  progressClock.value = Date.now();

  const imageReady = await handleSetImage({ showErrorToast: false });
  if (!imageReady) {
    return;
  }

  const predictionReady = await dummyPredict();
  if (!predictionReady) {
    return;
  }

  hasInitState.value = true;
  aigtDisplayPhase.value = 'running';
  progressClock.value = Date.now();
}

async function handlePredictImage({ clicks = null, box = null, targetAnnotationId = null }) {
  if (box && (box[2] - box[0] === 0 || box[3] - box[1] === 0)) {
    return;
  }

  let points;
  let labels;
  if (clicks) {
    points = clicks.map((click) => [click.x, click.y]);
    labels = clicks.map((click) => click.clickType);
  }

  const obj_id = selectedObject.value;
  const requestFrame = frame.value;
  const requestImageId = samples.value[requestFrame - 1];
  // Request payload
  const requestData = {
    points: clicks ? points : undefined,
    box: box || undefined,
    labels: clicks ? labels : undefined,
    image_id: requestImageId,
    annotation_set_id: destinationAnnotationSet.value?.id,
  };

  const timeout = setTimeout(() => {
    isAddingNewPointsOrBox.value = true;
  }, 3000);

  let requestFailed = false;
  // Sending a POST request
  const result = await fetch(`/aigt/image/predict?ip=${sam2ServerIp.value}`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify(requestData),
  })
    .then((response) => readAigtResponse(response, 'Error adding new point or box'))
    .catch((err) => {
      requestFailed = true;
      showAigtErrorToast(err, 'Error adding new point or box');
      return null;
    });
  clearTimeout(timeout);
  isAddingNewPointsOrBox.value = false;
  if (requestFailed) {
    return;
  }

  // The server answers null when SAM finds no object for the prompt
  const hasPrediction = result?.segmentations?.length || result?.boxes2d?.length || result?.boxes3d?.length;
  if (!hasPrediction) {
    $toast.open({
      queue: true, duration: 4000, message: 'SAM found no object for this prompt. Try a larger box or add points.', type: 'warning', position: 'top',
    });
    return;
  }

  if (targetAnnotationId) {
    addPolygonToExistingAnnotation(targetAnnotationId, result.segmentations?.[0]?.polygon);
    return result;
  }

  // Clear any points if a box was added
  if (box !== null) {
    sam2Options.value.params.clicks = sam2Options.value.params.clicks.filter((click) => click.obj_id !== obj_id);
  }
  if (!objectsLabelMap.value[obj_id]) {
    syncSelectedObjectLabel();
  }

  // Merge segmentation, 2D box and 3D box results for this object into a single combined annotation
  if (obj_id) {
    const segmentation = result.segmentations?.[0];
    const box2d = result.boxes2d?.[0]?.box2d;
    const box3d = result.boxes3d?.[0]?.box3d;

    if (segmentation?.polygon || box2d || box3d) {
      const mergedAnnotation = {
        id: `${obj_id}-f-${requestFrame}`,
        label_index: objectsLabelMap.value[obj_id].index,
        label_id: objectsLabelMap.value[obj_id].id,
        label_name: objectsLabelMap.value[obj_id].name,
        type: segmentation?.polygon ? "seg" : (box2d ? "box" : "3dbox"),
        score: 1,
        reviewStatus: 'verified',
        image_id: requestImageId,
        annotation_set_id: destinationAnnotationSet.value?.id,
        object_reference: obj_id,
        pending: true,
      };

      if (segmentation?.polygon) {
        mergedAnnotation.polygon = JSON.stringify(segmentation.polygon);
      }
      if (box2d) {
        mergedAnnotation.x = box2d.x;
        mergedAnnotation.y = box2d.y;
        mergedAnnotation.w = box2d.w;
        mergedAnnotation.h = box2d.h;
      }
      if (box3d) {
        mergedAnnotation.data_json = {
          x: box3d[0],
          y: box3d[1],
          z: box3d[2],
          dx: box3d[3],
          dy: box3d[4],
          dz: box3d[5],
        };
      }

      // Add the new annotation. Merge to existing annotation of the same object if it exists
      sam2Annotations.value = [
        ...sam2Annotations.value.filter((anno) => {
          const isSameImage = anno.image_id === requestImageId;
          const isSameObject = anno.object_reference === obj_id;
          return !(isSameImage && isSameObject);
        }),
        mergedAnnotation,
      ];
    }
  }

  // Parse the JSON response
  return result;
}

async function dummyPredict() {
  // Request payload
  const requestData = {
    box: [1.0, 1.0, 2.0, 2.0],
    image_id: 0,
    annotation_set_id: destinationAnnotationSet.value?.id,
  };

  // Sending a POST request
  const result = await fetch(`/aigt/image/predict?ip=${sam2ServerIp.value}`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify(requestData),
  })
    .then((response) => readAigtResponse(response, 'Error initializing AIGT prediction'))
    .catch(() => null);

  return result !== null && result !== undefined;
}

async function handleInitStateThenPropagate() {
  const boxes = sam2Options.value.params.boxes;
  const points = sam2Options.value.params.clicks;

  isPropagating.value = true;
  propagateLastAnnotationIndex.value = 0;
  propagateStatus.value = '';
  propagateDetail.value = '';
  propagateProgress.value = 0;
  propagateTotal.value = 0;

  const startFrameIdx = getFirstClickOrBoxFrameIndex();

  // Request payload
  const requestData = {
    start_frame_idx: startFrameIdx,
    max_frame_num_to_track: (initEndFrame.value - frame.value + 1),
    reverse: reversePropagateEnabled.value,
    sequence_id: sequenceId.value,
    image_ids: samples.value.slice(
      frame.value - 1,
      initEndFrame.value,
    ),
    points_or_boxes_requests: {
      points,
      boxes,
    },
    annotation_set_id: destinationAnnotationSet.value?.id,
  };

  if (reversePropagateEnabled.value) {
    const lastFrameIdx = getLastClickOrBoxFrameIndex();
    requestData.start_frame_idx = lastFrameIdx;
    requestData.max_frame_num_to_track = (frame.value - initEndFrameReverse.value + 1);
    requestData.image_ids = samples.value.slice(
      initEndFrameReverse.value - 1,
      frame.value,
    );
  }

  propagateStatus.value = 'started';
  propagateDetail.value = 'Processing selected frames';

  const result = await fetch(`/aigt/init_state_propagate?ip=${sam2ServerIp.value}`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify(requestData),
  })
    .then((response) => readAigtResponse(response, 'Error starting propagation'))
    .catch((error) => {
      isPropagating.value = false;
      showAigtErrorToast(error, 'Error starting propagation');
      return null;
    });

  // Parse the JSON response
  console.log("result:", result);

  if (result && !isFetchPropagateActive.value) {
    resumeFetchAnnotationsStatus();
    resumeFetchPropagateStatus();
  }
}

async function handlePropagateWs() {
  isPropagating.value = true;

  const socket = new WebSocket(`ws://${sam2ServerIp.value}:80/ws/aigt/propagate?start_frame_idx=${0}&max_frame_num_to_track=${samples.value.length}&reverse=${false}`);

  socket.onopen = () => {
    console.log('WebSocket connection established');
  };

  socket.onmessage = (event) => {
    try {
      const message = JSON.parse(event.data);
      console.log('Received:', message);

      // if (message.status === "complete") {
      //   isInitializingState.value = false;
      //   hasInitState.value = true;
      // }
      if (message?.progress) {
        propagateProgress.value = message.progress;
      }
      if (message?.total) {
        propagateTotal.value = message.total;
      }
      if (message?.status) {
        propagateStatus.value = message.status;
      }
      if (message?.detail) {
        propagateDetail.value = message.detail;
      }
      if (message?.polygon && message?.frame_idx >= 0) {
        const newAnnotationPolygon = {
          id: uuidv4(),
          label_index: objectsLabelMap.value[message.obj_id].index,
          label_id: objectsLabelMap.value[message.obj_id].id,
          label_name: objectsLabelMap.value[message.obj_id].name,
          type: "seg",
          polygon: JSON.stringify(message.polygon),
          score: 1,
          reviewStatus: 'verified',
          image_id: samples.value[(frame.value - 1) + message.frame_idx],
          annotation_set_id: destinationAnnotationSet.value?.id,
          pending: true,
        };

        sam2Annotations.value = [...sam2Annotations.value, newAnnotationPolygon];
      }
      if (message.status === "error") {
        isPropagating.value = false;
        // initError.value = message.detail;
      }
    } catch (error) {
      console.error('Error parsing WebSocket message:', error);
    }
  };

  socket.onerror = (error) => {
    console.error('WebSocket error:', error);
    isPropagating.value = false;
    // initError.value = error;
  };

  socket.onclose = (event) => {
    isPropagating.value = false;
    if (event.wasClean) {
      console.log(`WebSocket closed cleanly, code=${event.code}, reason=${event.reason}`);
    } else {
      console.error('WebSocket connection closed unexpectedly');
    }
  };
}

async function handleCancelPropagation() {
  isCancellingPropagation.value = true;
  // Sending a POST request
  return fetch(`/aigt/cancel_propagation?ip=${sam2ServerIp.value}`, {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
    },
  })
    .then(async (response) => {
      await readAigtResponse(response, 'Error cancelling propagation');
      isCancellingPropagation.value = false;
      return true;
    })
    .catch((err) => {
      isCancellingPropagation.value = false;
      showAigtErrorToast(err, 'Error cancelling propagation');
      return false;
    });
}

async function handleSAMClearAllPromptsInFrame(clicked_obj_id) {
  // Reset SAM2 Controls
  sam2Options.value.params.clicks = sam2Options.value.params.clicks.filter((click) => click.obj_id !== clicked_obj_id);
  sam2Options.value.params.boxes = sam2Options.value.params.boxes.filter((box) => box.obj_id !== clicked_obj_id);

  if (!currentSample.value?.imageObj?.sequence_id) {
    // Clear AIGT annotations for object_id
    sam2Annotations.value = sam2Annotations.value.filter((sam2anno) => !(sam2anno.object_reference === clicked_obj_id));
    aigt3dAnnotations.value = aigt3dAnnotations.value.filter((anno) => !(anno.object_reference === clicked_obj_id));
    aigt2dAnnotations.value = aigt2dAnnotations.value.filter((anno) => !(anno.object_reference === clicked_obj_id));

    return;
  }

  // Reset SAM2 annotations
  const sam2AnnotationsWithoutSameObjIdAndImageId = sam2Annotations.value.filter((sam2anno) => !(sam2anno.object_reference === clicked_obj_id && sam2anno.image_id === samples.value[frame.value - 1]));
  const lastProagatedSAM2Annotations = getFrameAndObjectSAM2LastPropagatedAnnotations(samples.value[frame.value - 1], clicked_obj_id);
  sam2Annotations.value = [...sam2AnnotationsWithoutSameObjIdAndImageId, ...lastProagatedSAM2Annotations];
  // Reset Aigt 3d annotations
  const aigt3dAnnotationsWithoutSameObjIdAndImageId = aigt3dAnnotations.value.filter((anno) => !(anno.object_reference === clicked_obj_id && anno.image_id === samples.value[frame.value - 1]));
  const lastProagatedAigt3dAnnotations = getFrameAndObjectAigt3dLastPropagatedAnnotations(samples.value[frame.value - 1], clicked_obj_id);
  aigt3dAnnotations.value = [...aigt3dAnnotationsWithoutSameObjIdAndImageId, ...lastProagatedAigt3dAnnotations];
  // Reset Aigt 2d annotations
  const aigt2dAnnotationsWithoutSameObjIdAndImageId = aigt2dAnnotations.value.filter((anno) => !(anno.object_reference === clicked_obj_id && anno.image_id === samples.value[frame.value - 1]));
  const lastProagatedAigt2dAnnotations = getFrameAndObjectAigt2dLastPropagatedAnnotations(samples.value[frame.value - 1], clicked_obj_id);
  aigt2dAnnotations.value = [...aigt2dAnnotationsWithoutSameObjIdAndImageId, ...lastProagatedAigt2dAnnotations];
}

async function handleSAMRemoveObject(clicked_obj_id) {
  // Reset SAM2 Controls
  sam2Options.value.params.clicks = sam2Options.value.params.clicks.filter((click) => click.obj_id !== clicked_obj_id);
  sam2Options.value.params.boxes = sam2Options.value.params.boxes.filter((box) => box.obj_id !== clicked_obj_id);
  // Reset SAM2 annotations
  const sam2AnnotationsWithoutObjId = sam2Annotations.value.filter((sam2anno) => sam2anno.object_reference !== clicked_obj_id);
  sam2Annotations.value = [...sam2AnnotationsWithoutObjId];
  // Reset 3D annotations
  const aigt3dAnnotationsWithoutObjId = aigt3dAnnotations.value.filter((aigt3danno) => aigt3danno.object_reference !== clicked_obj_id);
  aigt3dAnnotations.value = [...aigt3dAnnotationsWithoutObjId];
  // Reset 2D annotations
  const aigt2dAnnotationsWithoutObjId = aigt2dAnnotations.value.filter((aigt2danno) => aigt2danno.object_reference !== clicked_obj_id);
  aigt2dAnnotations.value = [...aigt2dAnnotationsWithoutObjId];
  // Remove object
  objects.value = objects.value.filter((obj) => obj !== clicked_obj_id);
  if (clicked_obj_id === selectedObject.value) {
    selectedObject.value = null;
  }
  delete objectsLabelMap.value[clicked_obj_id];
  // Disable clicks mode if no object remaining
  if (objects.value.length === 0) {
    sam2Options.value.mode = null;
    sam2Options.value.params.pointType = null;
  }
}

async function handleStartOver() {
  if (!currentSample.value?.imageObj?.sequence_id) {
    sam2Options.value.mode = 'drag_box';
    sam2Options.value.params.pointType = 'box';
    sam2Options.value.params.clicks = [];
    sam2Options.value.params.box = [];
    sam2Options.value.params.boxes = [];
    objects.value = [];
    selectedObject.value = null;
    handleSAMAddObject();
    const firstLabel = labels.value[0];
    if (firstLabel) {
      handleAssignLabel(firstLabel.id);
    }

    // Reset AIGT annotations
    sam2Annotations.value = [];
    aigt3dAnnotations.value = [];
    aigt2dAnnotations.value = [];
  } else {
    handleSAMReset();
  }
}

async function fetchPropagateStatus() {
  // Sending a POST request
  const result = await fetch(`/aigt/status?ip=${sam2ServerIp.value}`, {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
    },
  })
    .then((response) => readAigtResponse(response, 'Error fetching propagation status'))
    .catch((error) => {
      showAigtErrorToast(error, 'Error fetching propagation status');
      return null;
    });

  // Parse the JSON response

  if (result?.progress) {
    propagateProgress.value = result.progress;
  }
  if (result?.total) {
    propagateTotal.value = result.total;
  }
  if (result?.status) {
    propagateStatus.value = result.status;
  }
  if (result?.detail) {
    propagateDetail.value = result.detail;
  }
  if (result?.out_frame_idx) {
    let startFrameIdx = 0;
    if (isPropagating.value) {
      startFrameIdx = getFirstClickOrBoxFrameIndex();

      if (reversePropagateEnabled.value) {
        startFrameIdx = getLastClickOrBoxFrameIndex();
      }
    }

    if (result.out_frame_idx >= 0) {
      let frame_idx = result.out_frame_idx + startFrameIdx;

      if (reversePropagateEnabled.value) {
        frame_idx = result.out_frame_idx + endFrameModel.value - 1;
      }
      frame.value = frame_idx;
      emit('new-frame');
    }
  }
  // if (result?.polygon && result?.frame_idx >= 0) {
  //   const newAnnotationPolygon = {
  //     id: uuidv4(),
  //     label_index: selectedLabel.value.index,
  //     label_id: selectedLabel.value.id,
  //     label_name: selectedLabel.value.name,
  //     type: "seg",
  //     polygon: JSON.stringify(result.polygon),
  //     score: 1,
  //     reviewStatus: 'verified',
  //     image_id: samples.value[(frame.value - 1) + result.frame_idx],
  //     pending: true,
  //   };

  //   sam2Annotations.value = [...sam2Annotations.value, newAnnotationPolygon];
  // }
  if (result && result.status === 'cancelled') {
    pauseFetchPropagateStatus();
    pauseFetchAnnotationsStatus();
    // Check for annotations one more time
    await fetchAnnotationsStatus();
    isPropagating.value = false;
  }
  if (result && result.status === 'complete') {
    await fetchAnnotationsStatus();
    // Check for annotations one more time

    pauseFetchPropagateStatus();
    pauseFetchAnnotationsStatus();
    isPropagating.value = false;
    if (!reversePropagateEnabled.value) {
      frame.value = initEndFrame.value;
      emit('new-frame');
    } else {
      frame.value = initEndFrameReverse.value;
      emit('new-frame');
    }
  }
  if (result && result.status === 'error') {
    pauseFetchPropagateStatus();
    pauseFetchAnnotationsStatus();
    // Check for annotations one more time
    await fetchAnnotationsStatus();
    isPropagating.value = false;
  }
}

async function fetchAnnotationsStatus() {
  // Sending a POST request
  const result = await fetch(`/aigt/annotations?ip=${sam2ServerIp.value}&last_index=${propagateLastAnnotationIndex.value}`, {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
    },
  })
    .then((response) => readAigtResponse(response, 'Error fetching propagation annotations'))
    .catch((error) => {
      showAigtErrorToast(error, 'Error fetching propagation annotations');
      return null;
    });

  if (!isPropagating.value) {
    return;
  }

  // Parse the JSON response
  if (result?.last_index) {
    propagateLastAnnotationIndex.value = result.last_index;
  }
  let startFrameIdx = 0;
  if (isPropagating.value) {
    startFrameIdx = getFirstClickOrBoxFrameIndex();

    if (reversePropagateEnabled.value) {
      startFrameIdx = getLastClickOrBoxFrameIndex();
    }
  }

  if (result?.annotations) {
    // Merge polygon / box2d / box3d results that share the same object + frame into one annotation
    const mergedByKey = new Map();

    const getFrameIdx = (resultAnno) => {
      if (reversePropagateEnabled.value) {
        return resultAnno.frame_idx + endFrameModel.value - 1;
      }
      return resultAnno.frame_idx + startFrameIdx;
    };

    result.annotations.forEach((resultAnno) => {
      if (!resultAnno?.obj_id) {
        return;
      }

      const frame_idx = getFrameIdx(resultAnno);
      const key = `${resultAnno.obj_id}-f-${frame_idx}`;

      if (!mergedByKey.has(key)) {
        mergedByKey.set(key, {
          id: key,
          label_index: objectsLabelMap.value[resultAnno.obj_id].index,
          label_id: objectsLabelMap.value[resultAnno.obj_id].id,
          label_name: objectsLabelMap.value[resultAnno.obj_id].name,
          type: "seg",
          score: 1,
          reviewStatus: 'verified',
          image_id: samples.value[frame_idx],
          annotation_set_id: destinationAnnotationSet.value?.id,
          object_reference: resultAnno.obj_id,
          pending: true,
        });
      }
      const mergedAnnotation = mergedByKey.get(key);

      if (resultAnno.polygon && resultAnno.frame_idx >= 0) {
        mergedAnnotation.type = "seg";
        mergedAnnotation.polygon = JSON.stringify(resultAnno.polygon);
      }
      if (resultAnno.box2d) {
        mergedAnnotation.x = resultAnno.box2d.x;
        mergedAnnotation.y = resultAnno.box2d.y;
        mergedAnnotation.w = resultAnno.box2d.w;
        mergedAnnotation.h = resultAnno.box2d.h;
      }
      if (resultAnno.box3d) {
        mergedAnnotation.data_json = {
          x: resultAnno.box3d[0],
          y: resultAnno.box3d[1],
          z: resultAnno.box3d[2],
          dx: resultAnno.box3d[3],
          dy: resultAnno.box3d[4],
          dz: resultAnno.box3d[5],
        };
      }
    });

    const mergedAnnotations = Array.from(mergedByKey.values());
    const mergedKeys = new Set(mergedAnnotations.map((anno) => `${anno.image_id}-${anno.object_reference}`));

    sam2Annotations.value = [
      ...sam2Annotations.value.filter((anno) => !mergedKeys.has(`${anno.image_id}-${anno.object_reference}`)),
      ...mergedAnnotations,
    ];
    sam2LastPropagatedAnnotations.value = [
      ...sam2LastPropagatedAnnotations.value.filter((anno) => !mergedKeys.has(`${anno.image_id}-${anno.object_reference}`)),
      ...mergedAnnotations,
    ];
  }
}

function getFirstClickOrBoxFrameIndex() {
  const boxes = sam2Options.value.params.boxes;
  const clicks = sam2Options.value.params.clicks;
  const minBoxFrameIdx = boxes.reduce((min, obj) => (obj.frame_idx < min ? obj.frame_idx : min), initEndFrame.value);
  const minClickFrameIdx = clicks.reduce((min, obj) => (obj.frame_idx < min ? obj.frame_idx : min), initEndFrame.value);
  return Math.min(minBoxFrameIdx, minClickFrameIdx);
}

function getLastClickOrBoxFrameIndex() {
  const boxes = sam2Options.value.params.boxes;
  const clicks = sam2Options.value.params.clicks;
  const maxBoxFrameIdx = boxes.reduce((max, obj) => (obj.frame_idx > max ? obj.frame_idx : max), 0);
  const maxClickFrameIdx = clicks.reduce((max, obj) => (obj.frame_idx > max ? obj.frame_idx : max), 0);
  return Math.max(maxBoxFrameIdx, maxClickFrameIdx);
}

async function fetchServerHealth() {
  fetchingServerHealth.value = true;

  try {
    const response = await fetch('/aigt/server', {
      method: 'GET',
      headers: {
        Authorization: `Bearer ${store.state.user.token}`,
      },
    });

    const payload = await readAigtResponse(response, 'Failed to check AGTG server');

    const server = payload?.result?.server;

    serverHealthCheckedOnce.value = true;
    const isReady = Boolean(server?.ready);

    if (!server || (!server.id && !server.ip)) {
      isSam2ServerFound.value = false;
      isSam2ServerAvailable.value = false;
      fetchingServerHealth.value = false;
      pauseFetchServerHealth();
      emit('server-inactive');
      return;
    }

    sam2Server.value = server;
    isSam2ServerFound.value = true;
    isSam2ServerAvailable.value = isReady;
    fetchingServerHealth.value = false;

    if (isReady) {
      if (objects.value.length === 0) {
        handleSAMAddObject();
        syncSelectedObjectLabel();
      }
      if (!hasInitState.value && !isInitializingState.value) {
        await initializeAigtServer();
      } else if (hasInitState.value) {
        aigtDisplayPhase.value = 'running';
      }
      return;
    }

    if (!isFetchServerHealthActive.value) {
      resumeFetchServerHealth();
    }
  } catch (err) {
    isSam2ServerFound.value = false;
    isSam2ServerAvailable.value = false;
    fetchingServerHealth.value = false;
    serverHealthCheckedOnce.value = true;
    pauseFetchServerHealth();
    emit('server-inactive');
  }
}

function shutdownAGTGServer() {
  confirmMessage.value = 'Are you sure you want to shutdown the AGTG Server? All current changes will be lost.';
  confirmMessageHeader.value = 'Shutdown AGTG Server';
  confirmButtonClass.value = 'button-delete';
  confirmButtonText.value = 'Shutdown AGTG Server';
  confirmModal.value.showModal();
  confirmFunction.value = () => { deleteAGTGServer(); };
}

async function deleteAGTGServer() {
  const dataConnect = new DatastoreConnect();
  const params = {
    cloud_instance_ids: [sam2Server.value.id],
  };
  dataConnect.stopMultipleCloudInstance(params)
    .then(async (resp) => {
      if (resp.error !== undefined) {
        throw Error(resp.error.message);
      }
      $resetServer();
      sam2Server.value = null;
      $toast.open({
        queue: true,
        duration: 5000,
        message: `AGTG Server successfully terminated`,
        type: "success",
        position: "top",
      });
      isSam2ServerFound.value = false;
      isSam2ServerAvailable.value = false;
      emit('mode', 'pointer');
    })
    .catch((error) => {
      console.log(error);
      $toast.open({
        queue: true,
        duration: 5000,
        message: `AGTG Server failed to terminate`,
        type: "error",
        position: "top",
      });
    });
}



defineExpose({
  handleNewFrame,
});

</script>

<style lang="scss" scoped>
.aigt-task-loader {
  width: 28px;
  height: 28px;
  margin: 20px auto;
  border: 3px solid rgba(37, 14, 129, 0.2);
  border-top-color: #250e81;
  border-radius: 50%;
  animation: aigt-task-loader-spin 0.8s linear infinite;
}

@keyframes aigt-task-loader-spin {
  to {
    transform: rotate(360deg);
  }
}

.sam-toolbar {
  display: flex;
  flex-direction: row;
  align-items: center;

  &__group {
    display: flex;
    flex-direction: row;
    align-items: center;
    gap: 12px;
  }

  &__group + &__group {
    margin-left: 12px;
  }

  &__vr {
    display: flex;
    width: 1px;
    height: 60%;
    margin: 0 8px;
  }

  &__title {
    font-weight: 700;
    font-size: 0.9rem;
    @include themify() {
      color: themed('color-primary');
    }
  }

  &__button-container {
    position: relative;
  }

  &__button {
    border-radius: 4px !important;

    &._secondary {
      color: inherit;
      background: none;
      border: none;
      box-shadow: none;

      &:hover:not(:disabled), &.active:not(:disabled) {
        background-color: var(--icon-hover-color);
        // box-shadow: 0 0 0 4px rgba(140, 140, 140, 0.2);
      }

      &:disabled {
        box-shadow: none !important;
        background-color: transparent !important;
        cursor: default;
        color: var(--color-disabled) !important;
      }
    }

    &._danger {
      color: var(--color-white);
      background: var(--color-danger);
      border: none;
      box-shadow: none;

      &:hover:not(:disabled), &.active:not(:disabled) {
        background-color: var(--color-danger-400);
        // box-shadow: 0 0 0 4px rgba(140, 140, 140, 0.2);
      }

      &:disabled {
        box-shadow: none !important;
        background-color: transparent !important;
        cursor: default;
        color: var(--color-disabled) !important;
      }
    }

  }

  &__button-pointer-overlay {
    display: flex;
    position: absolute;
    width: 14px;
    height: 14px;
    top: -3px;
    right: -2px;
    pointer-events: none;
    @include themify() {
      color: themed('color-primary');
    }
  }

  &__labeled_button {
    width: auto;
  }
}

.v-number-input * {
  --v-input-control-height: 28px;
  --v-input-padding-top: 0px;
  --v-field-input-padding-top: 0px;
  --v-field-input-padding-bottom: 0px;
  --v-field-padding-bottom: 0px;
  --v-icon-size-multiplier: 0.5;
}

.v-text-field * {
  --v-input-control-height: 28px;
  --v-input-padding-top: 0px;
  --v-field-input-padding-top: 0px;
  --v-field-input-padding-bottom: 0px;
  --v-field-padding-bottom: 0px;
  --v-icon-size-multiplier: 0.5;
  // --v-field-padding-start: 0;
  // --v-field-padding-end: 0;
}

.sam-sidebar {
  display: flex;
  flex-direction: column;
  align-items: center;
  flex: 1 1 auto;
  min-height: 0;
  overflow-x: hidden;
  overflow-y: auto;

  &__section {
    display: flex;
    flex-direction: column; /* Stack title and list vertically */
    // margin-bottom: 8px;
    border-bottom: 1px solid #ced4da;
    width: 100%;
    padding: 12px 12px 12px 12px;
    flex: 0 0 auto;
  }

  &__title {
    display: flex;
    align-items: center;
    text-align: left;
    font-size: 1rem;
    font-weight: 600;
    color: var(--body-text-color-secondary);
    padding-bottom: 12px;
    letter-spacing: 0.025em;
    gap: 6px;
  }
}

.init-state {
  h2 {
    display: flex;
    flex-direction: row;
  }

  &__inputs {
    display: flex;
    flex-direction: row;
    gap: 8px;
    padding-bottom: 8px;
  }
}

.controls {
  &__buttons {
    display: flex;
    flex-direction: row;
    gap: 12px;
  }
}

.propagate {
  &__buttons {
    display: flex;
    flex-direction: column;
    gap: 12px;
    align-items: center;
    width: 100%;
  }

  &__buttons-main {
    display: flex;
    flex-direction: row;
    gap: 12px;
    align-items: center;
    width: 100%;
  }

  &__action-button {
    flex: 1 1 auto;
  }

  &__cancel-button {
    width: 100%;
  }
}

.objects {
  &__cards {
    display: flex;
    flex-direction: column;
    gap: 8px;
    overflow: auto;
    padding: 4px;
    flex: 0 0 auto;
    max-height: 45vh;
    margin-bottom: 12px;
  }
}

.objects-card {
  position: relative;
  display: flex;
  flex-direction: column;
  width: 100%;
  background: var(--color-white-600);
  border-radius: 4px;
  box-shadow: 1px 1px 4px 1px rgba(0, 0, 0, 0.2), 0 0 1px 1px rgba(0, 0, 0, 0.05);
  padding: 8px;
  cursor: pointer;

  &._selected {
    outline: 3px solid var(--color-primary);
  }

  &__title {
    text-align: left;
    font-size: 0.875rem;
    font-weight: 600;
    color: var(--color-primary);
    padding-bottom: 12px;
    letter-spacing: 0.025em;
    display: flex;
    flex-direction: row;
  }

  &__buttons {
    display: flex;
    flex-direction: row;
    gap: 12px;
    align-items: center;
  }

  &__edit-button {
    flex: 1 1 auto;
  }

  &__close {
    position: absolute;
    top: 10px;
    right: 10px;
  }
}

.check-box-text {
  font-size: 0.9rem;
  color: var(--body-text-color-secondary);
  font-weight: 600;
  letter-spacing: 0;
  margin-left: 5px;
}

.help-icon {
  margin: 0 5px;
  color: var(--color-primary);
}

.help-icon:focus {
  outline: none;
}

.label-select {
  width: 80%;
  font-size: 16px;
  border-radius: 6px;
  padding: 3px 0 3px 10px;
  background: field;
  @include themify() {
    border: 1px solid themed('form-input-border');
  }

}
</style>
